(function (Wishlist, $) {
  var $wishlistButton = $('.wishlist-btn');
  var $wishlistTile = $('.wishlist-tile-container');
  var $wishlistAddtoCart=$('.add-to-cart-wishlist');
  var removeWishlistItem=$('.removeWishlistItem');
  var numProductTiles   = $('.wishlist-widget-products:first li').length;
  var wishlist = localStorage.getItem('merketo_wishlist') || [];
  var wishlistcount = parseInt(localStorage.getItem('merketo_wishlist_count')) || 0;
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('merketo_wishlist'));
  }
   /*
   * Update button to show current state (gold for active)
   */
   var animateWishlist = function (self) {
     var selfhandle=$(self).attr('data-product-handle')
     $('.add-to-wishlist.wishlist a[data-product-handle="'+selfhandle+'"]').toggleClass('is-active');
   };
   var getitembyHander = function(self){
    Shopify.getProduct(self,headeritemupdate)
  }
  var headeritemupdate = function(self){
   var sym=$('.xs-wish-list-item').data('currency');
   var html='<li class="mini_cart_item media" data-product-handle="'+self.handle+'">'
   +'<a class="d-flex mini-product-thumb">'
   +'<img src="'+self.featured_image+'" alt="'+self.handle+'">'
   +'</a>'
   +'<div class="media-body">'       
   +'<h4 class="mini-cart-title"><a href="/products/'+ self.handle +'">'+ self.handle +'</a></h4>'
   +'<span class="shopify-Price-amount amount">'+Shopify.formatMoney(self.price, sym)+'</span>'
   +'</div>'
   +'<button class="btn-cancel pull-right removeWishlistItem">x</button>'
   +'</li>';

   $('.wishlist-widget-products').append(html)
   if ($('.wishlist-widget-products li').length == 0) {
    $('.wishlist-grid--empty-list').addClass('is_visible');
    $('.dropdown-menu').hide();
    } else {
      $('.wishlist-dropdown').show()
      $('.wishlist-grid--empty-list').hide();
    }
    $('.wishlist-count').text(wishlistcount)
    $('.add-to-wishlist.wishlist a[data-product-handle="'+self.handle+'"]').addClass('is-active')
    console.log('success')
  }
  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   
   var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('is-active');
    if (isRemove) {
      removeItemfromWishlist(self,true)
    }else {
      wishlist.push(productHandle);
      wishlist = Array.from(new Set(wishlist))
      localStorage.setItem('merketo_wishlist', JSON.stringify(wishlist));
      wishlistcount=wishlistcount+1;
      localStorage.setItem('merketo_wishlist_count', wishlistcount);
      getitembyHander(productHandle);
      numProductTiles++;
    }
  };
  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
   var activateItemsInWishlist = function () {
     $('.wishlist-btn').each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('is-active');
      }
    });
   };
  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   
   var displayOnlyWishlistItems = function () {
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
  };
  
  var remove = function () {
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
  };
  var removeItemfromWishlistPopup=function (self){
   $('.wishlist-widget-products li').each(function(){
     if($(this).attr('data-product-handle')==self)
       $(this).replaceWith('')
   })
 }

 var t = false
 var removeItemfromWishlist=function ($this, t){
  var productHandle = $($this).attr('data-product-handle');
  if(!t)
    $($this).replaceWith('')
  var removeIndex = wishlist.indexOf(productHandle);
  wishlist.splice(removeIndex, 1);
  localStorage.setItem('merketo_wishlist', JSON.stringify(wishlist));
  wishlistcount=wishlistcount-1;
  localStorage.setItem('merketo_wishlist_count',wishlistcount );
  numProductTiles--;
  if (numProductTiles == 0) {
    $('.wishlist-grid--empty-list').addClass('is_visible');
    $('.wishlist-grid--empty-list').show();
    $('.wishlist-dropdown').hide()
    } else {
      $('.wishlist-dropdown').show()
      $('.wishlist-grid--empty-list').hide();
    }
    removeItemfromWishlistPopup(productHandle)
    $('.wishlist-count').text(wishlistcount)
  }
  
  var bindaddTocart = function () {
    $wishlistAddtoCart.on('click',function(){
      Shopify.addItemWishList($(this).attr('data'), 1,mini_cart_add)
      removeItemfromWishlist($(this).closest('.wishlist-tile-container'))
    })
  };
  var removeWishList = function () {
    removeWishlistItem.on('click',function(){
      removeItemfromWishlist($(this).closest('.wishlist-tile-container'))
    })
  };
  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
   var loadWishlist = function () {
    if ($('.wishlist-tile-container').length) {
      displayOnlyWishlistItems();
      bindaddTocart();
      removeWishList();
      $('.wishlist-grid').addClass('is_visible');
      $('.wishlist-hero').addClass('is_visible');
      numProductTiles   = $('.wishlist-widget-products:first li').length;
      if (numProductTiles == 0) {
        $('.wishlist-grid--empty-list').addClass('is_visible');
        $('.wishlist-grid--empty-list').show();
        $('.wishlist-dropdown').hide()
      } else {
        $('.wishlist-dropdown').show()
        $('.wishlist-grid--empty-list').hide();
      }
    }
    $('.wishlist-count').text(wishlistcount)
  };
  
  var bindUIActions = function () {
    $(document).off('click.wishlist');
    $(document).on('click.wishlist','.wishlist-btn',function(e){
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    }) 
  };

  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
  };

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));